const config = {
  telegram_name: "@matrixnor",
  telegram_link: "https://t.me/matrixnor",
  api: "http://matrixnor.voronin.xyz/api/sendmail",
};

export default config;
